import React, { useState } from 'react';
import { Box, styled, Typography } from '@mui/material';
import { formatPrice } from '../../utils/numberFormatter';
import { useTranslation } from 'react-i18next';
import { getCurrency } from '../../utils/utils';
import { Variant } from '../../models/Product';

const StyledPriceWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    paddingTop: '15px',
}));

const StyledElement = styled(Box)(({ theme }) => ({
    flex: '0 0 50%',
}));

const StyledNetPrice = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: '26px',
    color: '#2b7291',
}));

const StyledGrossPrice = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
}));

export const ProductPrices = (props: { variant: Variant }) => {
    const variant = props.variant;
    const { t } = useTranslation('product');

    return (
        <StyledPriceWrapper>
            <StyledElement>
                <Typography>{t('PRODUCT.GROSS')}</Typography>
                {variant.compareAtPrice && (
                    <Typography sx={{ textDecoration: 'line-through' }}>
                        {formatPrice(variant.compareAtPrice.amount)}{' '}
                        {getCurrency(variant.compareAtPrice.currencyCode)}
                    </Typography>
                )}
                <StyledGrossPrice>
                    {formatPrice(variant.price.amount)}{' '}
                    {getCurrency(variant.price.currencyCode)}
                </StyledGrossPrice>
            </StyledElement>
            <StyledElement>
                <Typography>{t('PRODUCT.NET')}</Typography>
                {variant.compareAtPrice && (
                    <Typography sx={{ textDecoration: 'line-through' }}>
                        {formatPrice(variant.compareAtPrice.amount / 1.27)}{' '}
                        {getCurrency(variant.compareAtPrice.currencyCode)}
                    </Typography>
                )}
                <StyledNetPrice>
                    {formatPrice(variant.price.amount / 1.27)}{' '}
                    {getCurrency(variant.price.currencyCode)}
                </StyledNetPrice>
            </StyledElement>
        </StyledPriceWrapper>
    );
};
